<template>
  <div
    class="show-box body-box scroll-y info-container bg-white min-body-height"
    v-if="User.user.role"
  >
    <Default></Default>
    <UserInfo></UserInfo>
    <OrgInfo></OrgInfo>
    <OrgPlayer v-if="User.user.role == $roleConsts.ORG.value"></OrgPlayer>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Default from './defaultInfo.vue';
import UserInfo from './userInfo.vue';
import OrgInfo from './orgInfo.vue';
import OrgPlayer from './orgPlayerList.vue';

import { wxShareMixins } from '@/mixins/wx_share.js';

export default {
  mixins: [wxShareMixins],
  components: {
    Default,
    UserInfo,
    OrgInfo,
    OrgPlayer,
  },

  computed: {
    ...mapState(['User', 'UI']),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/info/index.vue